export default __webpack_public_path__ + "static/logo-color-2535924b54efb47c5382c92aecc4da3e.svg";